<template>
  <div>
    <!-- 顶部 -->
    <detailHeader />
    <div class="content">
      <!--群发信息  -->
      <h1>{{ $t("message.massMessaging") }}</h1>
      <el-form :model="datas" :rules="rules" ref="datas" label-width="150px" class="demo-ruleForm">
        <!-- 通告群体： -->
        <el-form-item :label="$t('message.noticeGroup') + ':'" prop="type">
          <el-select v-model="datas.type" placeholder="请选择" @change="changeNange">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 人员选择 -->
        <el-form-item :label="$t('message.personnelSelection') + ':'" v-if="datas.type == '部分客户'">
          <div class="value">
            <div class="button">
              <!-- 选择 -->
              <el-button type="primary" class="primary" @click="choose">
                {{ $t("message.choose") }}
              </el-button>
            </div>
            <!-- 部分客户 -->
            <div class="table" v-if="datas.type == '部分客户'">
              <el-table :data="selectedPersonnel" :default-sort="{ prop: 'date', order: 'descending' }"
                :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%" max-height="400px">
                <el-table-column align="center" type="index" width="80" label="NO">
                </el-table-column>
                <!-- 客户ID -->
                <el-table-column align="center" :label="$t('message.clientID')" prop="id">
                </el-table-column>
                <!-- 客户名称 -->
                <el-table-column align="center" :label="$t('message.userName')" prop="realname">
                </el-table-column>
                <!-- 删除 -->
                <el-table-column :label="$t('message.delete')" align="center">
                  <template slot-scope="scope">
                    <el-button size="mini" type="danger" @click="delSelectedPersonnel(scope.row.id)">
                      {{ $t("message.delete") }}
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>

          </div>
        </el-form-item>
        <!-- 发送时间 -->
        <el-form-item :label="$t('message.sendTime') + ':'" prop="send_at" placeholder="请选择">
          <el-date-picker v-model="datas.send_at" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="请选择发送时间" />
        </el-form-item>
        <!-- 消息内容 -->
        <el-form-item :label="$t('message.messageContent') + ':'" prop="content">
          <el-input type="textarea" v-model="datas.content"></el-input>

        </el-form-item>
        <!-- 定时发送时间： -->
        <!-- <el-form-item :label="$t('message.timedTransmissionTime') + ':'">
          <el-date-picker v-model="datas.send_date" type="datetime" :placeholder="$t('message.timedTransmissionTime')"
            value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item> -->

      </el-form>
      <!-- 预览 -->
      <div class="btn">
        <!-- 保存 -->
        <el-button type="primary" @click="RCMsgPush">
          {{ $t("message.save") }}
        </el-button>
        <!--取 消  -->
        <el-button type="primary" class="dark">
          {{ $t("message.cancel") }}
        </el-button>
      </div>
    </div>
    <!-- 人员选择 -->
    <el-dialog :title="$t('message.personnelSelection')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="800px" center>
      <div class="body">
        <div class="search">
          <!-- 客户ID： -->
          <div class="label">
            {{ $t("message.clientID") }}:
          </div>
          <!--搜索  -->
          <div class="value">
            <el-input v-model="personnelData.searchText" onfocus="this.select()" clearable></el-input>
          </div>
          <!-- <div class="value">
            <el-select v-model="personnelData.section" placeholder="请选择部门" clearable>
              <el-option label="一部" value="一部">
              </el-option>
              <el-option label="二部" value="二部">
              </el-option>
              <el-option label="三部" value="三部">
              </el-option>
            </el-select>
          </div> -->
          <!-- 查询 -->
          <div class="label" style="width: 60px;">
            <el-button type="primary" @click="getAccountInfo">
              {{ $t("message.inquire") }}
            </el-button>
          </div>
        </div>
        <el-table :data="user_id_set" border :header-cell-style="{ background: '#EDEFF4' }" max-height="500px">
          <!-- 客户ID -->
          <el-table-column prop="id" :label="$t('message.clientID')" align="center">
          </el-table-column>
          <!--客户名称-->
          <el-table-column prop="realname" :label="$t('message.customerName')" align="center">
          </el-table-column>
          <!-- 删除 -->
          <el-table-column align="center">
            <template slot-scope="scope">
              <el-button size="mini" type="danger" @click="delItem(scope.row.id)">
                {{ $t("message.delete") }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">
          {{ $t("message.cancel") }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">
          {{ $t("message.ok") }}
        </el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="picDialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>
<script>
import detailHeader from "@/components/header/detailHeader";
import { quillEditor } from "vue-quill-editor";
import quillConfig from "@/utlis/quill-config";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
export default {
  components: {
    detailHeader,
    quillEditor,
  },
  data() {
    return {
      datas: {
        content: "",
        type: "", //10-全部客户,11-部分客户,20-全部管理员,21-部分管理员
        user_id_set: [],

      },
      dialogImageUrl: '',
      picDialogVisible: false,
      rules: {
        content: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],

        type: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
      },
      options: [
        {
          label: "全部客户",
          value: "全部客户",
        },
        {
          label: "部分客户",
          value: "部分客户",
        },

      ],
      quillOption: quillConfig,
      //   人员选择
      dialogVisible: false,
      selectedPersonnel: [],
      user_id_set: [],
      personnelData: {
        searchText: "",
        section: "",
        type: 'user',
      },
    };
  },
  methods: {
    onEditorChange(e) {
      console.log(e);
    },
    //状态筛选
    changeNange(e) {
      this.selectedPersonnel = [];
    },
    // 选择
    choose() {
      this.user_id_set = [];
      this.personnelData.searchText = "";
      this.personnelData.section = "";
      this.dialogVisible = true;
    },
    //人员搜索
    getAccountInfo() {
      this.$api.siteConfiguration
        .getAccountInfo(this.personnelData)
        .then((res) => {
          if (res.data == false) {
            return this.$message.error("未匹配此ID");
          }
          this.user_id_set = [... this.user_id_set, ...res.data.batch]
          var hash = {};
          this.user_id_set = this.user_id_set.reduce(function (item, next) {
            hash[next.id]
              ? ""
              : (hash[next.id] = true && item.push(next));

            return item;
          }, []);
        });
    },
    // 删除未选择人员
    delItem(id) {
      let index = this.user_id_set.findIndex((item) => item.id == id);
      this.user_id_set.splice(index, 1);
    },
    //删除已选择的
    delSelectedPersonnel(id) {
      let index = this.selectedPersonnel.findIndex((item) => item.id == id);
      this.selectedPersonnel.splice(index, 1);
    },
    //人员保存
    save() {
      console.log(this.user_id_set);

      this.selectedPersonnel = [...this.selectedPersonnel, ...this.user_id_set];
      this.dialogVisible = false;
    },
    // 上传成功
    avatarSuccess(res,) {
      this.datas.image = res.data
    },
    // 删除
    handleRemove(file, fileList) {
      this.images = fileList
    },
    // 查看大图
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.picDialogVisible = true
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个图片，本次选择了 ${files.length} 个图片，共选择了 ${files.length + fileList.length} 个图片`);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      // this.loading = true;
      if (!isJPG && !isPNG) {
        this.$message.error("上传图片只能是 JPG和PNG 格式!");
        // this.loading = false;
      }
      return isJPG || isPNG;
    },
    //群发消息模版添加
    RCMsgPush() {
      this.$refs.datas.validate((valid) => {
        if (valid) {
          this.selectedPersonnel.forEach(item => {
            this.datas.user_id_set.push(item.id)
          })
          this.$confirm(
            '  请再次确认是否发送通知，通知一经发送无法取消',
            // 提示
            this.$t("message.prompt"),
            {
              // 确定
              confirmButtonText: this.$t("message.ok"),
              // 取消
              cancelButtonText: this.$t("message.cancel"),
              type: "warning",
              center: true
            }
          )
            .then(() => {
              this.$api.noticeApi.RCMsgPush(this.datas).then((res) => {
                this.$message.success(res.msg);
                this.$router.push("/menu3_config_notice?activeName=3");
              });
            })
            .catch(() => { });



        }
      });


    },
  },
};
</script>
<style lang='scss' scoped>
h1 {
  font-size: 25px;
  font-weight: 600;
  margin: 0 0 40px;
  text-align: center;
}

.content {
  background: #f8f8f8;
  border-radius: 0px 8px 8px 8px;
  padding: 24px;
  margin: 24px;
  min-width: 1814px;

  .value {
    flex: 1;
    display: flex;

    .button {
      width: 100px;
      margin-right: 40px;
    }

    .table {
      width: 500px;
    }
  }

  /deep/.el-form-item__label {
    font-size: 20px;
  }

  /deep/.el-textarea__inner {
    height: 100px;
  }
}

/deep/.el-textarea__inner {
  min-height: 300px !important;
}

.search {
  display: flex;
  margin-bottom: 20px;
  line-height: 40px;

  .label {
    width: 120px;
    text-align: right;
  }

  .value {
    flex: 1;
    margin: 0 30px;
  }
}

.btn {
  text-align: center;
}

/deep/.el-upload {
  border: none;
}

/deep/.el-upload-dragger {
  width: 120px !important;
  height: 120px !important;
}
</style>